import React, { Component } from "react";

import autoattend from "../../../Assets/img/auto_attend_logo.png";
import hastag from "../../../Assets/img/logo_hastag.png";


class Poweredby_after extends Component {

  constructor(props) {
    super(props);
    this.state = {
      validation_alert : false,
      validation_error : false,
      validation_blank : false,
    };
  }
 
  
  render() {
    return (
      <div className="Prizes">
        <div className="">
        <div className="section-powered-by">
            <div className="section-end pt-4 pb-4">
        <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12 col-12">
                  <h4>These guys makes us run this game…</h4>
                  <p>The generous contributions of our corporate sponsors give us the ability to do so much more. These businesses and organizations find value in our work and support us. If you would like to sponsor, do get in touch.</p>
                  <div className="text-left sponsor_buttons">
                 <a href="/become-sponsor" className="btn btn-yellow mt-3"> BECOME A SPONSOR </a>
                  
                 <a href="/private-puzzled" className="btn btn-yellow mt-3 ml-4" style={{padding:"7PX 28PX"}}>  HOST AN EVENT </a> 
                </div> 
              </div>
              <div className="col-lg-6 col-md-12 col-12 powered_by">
              <div className="container">
              <div className="row">
                 <div className="col-4 offset-2">
                    <a href="https://autoattend.com/" target="_blank" rel="noopener noreferrer"> <img src={autoattend} alt="" /> </a>
                  </div>
                  <div className="col-4">
                    <a href="https://www.hashtagtechnologies.com/" target="_blank" rel="noopener noreferrer"> <img src={hastag} alt="" /> </a>
                  </div>
              </div>
              </div>
            </div>
            </div>
        </div>
      </div>
        </div>
        </div>  
      </div>
    );
  }
}

export default Poweredby_after;
